import { MonthName } from "./types";

export const translations: Record<string, Record<MonthName, string>> = {
  pt: {
    January: "Janeiro",
    February: "Fevereiro",
    March: "Março",
    April: "Abril",
    May: "Maio",
    June: "Junho",
    July: "Julho",
    August: "Agosto",
    September: "Setembro",
    October: "Outubro",
    November: "Novembro",
    December: "Dezembro",
  },
  en: {
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
  },
};

export const translateMonth = (monthName: string, locale: string = "pt"): string => {
  return translations[locale]?.[monthName as MonthName] || monthName;
};
